import Grid from '@material-ui/core/Grid';
import Field from '../Field';

const compareAddresses = (primary, mailing) => {
  if (!primary || !mailing) return false;
  const same = type => primary[type] === mailing[type];
  return (
    same('city') &&
    same('state') &&
    same('addressLine1') &&
    same('addressLine2') &&
    same('zipCode')
  );
};

const Addresses = props => {
  const { mailing, primary } = props;
  const join = (separator, ...items) => items.filter(Boolean).join(separator);
  const sameAddress =
    !mailing || !mailing.addressLine1 || compareAddresses(primary, mailing);
  const address = type =>
    join(
      ', ',
      join(' ', type.addressLine1, type.addressLine2),
      type.city,
      join(' ', type.state, type.zipCode),
    );

  return (
    <Grid container spacing={2} style={{ flexGrow: 1 }}>
      <Grid item xs={12}>
        <Field label="Permanent Address" value={address(primary)} />
      </Grid>
      <Grid item xs={12}>
        <Field
          label="Mailing Address"
          value={
            sameAddress ? (
              <strong>Same as Permanent Address above</strong>
            ) : (
              address(mailing)
            )
          }
        />
      </Grid>
    </Grid>
  );
};

export default Addresses;
